<template>
    <div class="container">
        <div class="info">
            <div class="info-item" v-for="(item, index) in infos" :key="index">
                <div style="padding:24px 32px">
                    <div class="title">{{ item.title }}</div>
                    <div class="num">{{ item.num }}</div>
                </div>

                <div class="line" v-if="index < infos.length - 1"></div>
            </div>
        </div>
        <div class="content">
            <el-form :inline="true" :model="searchForm" ref="searchForm" class="search-form" size="small" label-width="64px">
                <el-form-item label="应聘岗位">
                    <el-select v-model="searchForm.recruitPost" placeholder="请选择" clearable>
                        <el-option v-for="item in dictionaries.recruit_post" :key="item.dictId" :label="item.dictName" :value="item.dictId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="应聘者姓名">
                    <template #label>
                        <div style="width: 64px;display: flex;justify-content: space-between;box-sizing: border-box;padding-right: 8px;flex-direction: column;line-height: 16px;">
                            <div>应聘者</div>
                            <div>姓名</div>
                        </div>
                    </template>
                    <el-input v-model="searchForm.name" placeholder="请输入" clearable></el-input>
                </el-form-item>
                <el-form-item label="应聘阶段">
                    <el-select v-model="searchForm.status" placeholder="请选择" clearable>
                        <el-option v-for="item in dictionaries.recruit_status" :key="item.dictId" :label="item.dictName" :value="item.dictId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="应聘部门" prop="name">
                    <el-select v-model="searchForm.orgName" placeholder="请选择" clearable>
                        <el-option v-for="item in positions" :key="item.orgCode" :label="item.orgName" :value="item.orgName">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="应聘日期">
                    <eldate @changeData="changeData($event)" :dateData="applyTime"></eldate>
                </el-form-item>
                <el-form-item>
                    <div style="display: flex;">
                        <div class="s-btn" @click="fetchData('search')">查询</div>
                        <div class="r-btn" @click="fetchData('reset')">重置</div>
                    </div>
                </el-form-item>
            </el-form>
            <div class="line"></div>
            <div class="data-title">
                <div style="display: flex;height: 32px;">
                    <div class="title-line"></div>
                    <div class="title-name">数据列表</div>
                </div>

                <div class="title-btn">
                    <div class="title-btn-item" style="margin-right: 12px;" @click="deliverData()">
                        <img src="../../../assets/icon_daochu.png" style="width: 16px;height: 16px;" />
                        <div class="btn-l">导出列表</div>
                    </div>
                    <div class="title-btn-item" style="margin-right: 12px;" @click="alotPrint()">
                        <img src="../../../assets/icon_dayin.png" style="width: 16px;height: 16px;" />
                        <div class="btn-l">批量打印</div>
                    </div>
                    <div class="title-btn-item" @click="add">
                        <i class="el-icon-plus"></i>
                        <div class="btn-l">新增应聘信息</div>
                    </div>
                </div>
            </div>
            <lb-table v-horizontal-scroll="'always'" :column="columns" :data="list" pagination :total="totalNum" layout="total, sizes, prev, pager, next, jumper" :page-sizes="[5, 10,20,30,50,200,2000]"
                :current-page.sync="page.pageNo" :page-size="page.pageSize" @selection-change="onMultipleSelection" @size-change="handleSizeChange" @p-current-change="handleCurrentChange">
            </lb-table>

        </div>
        <!--确认 -->
        <el-dialog title="提示" :visible.sync="isConfirm" width="268px" append-to-body>
            <div style="font-size: 14px;color: #2F3030;line-height: 22px;text-align: center;margin-left:12px">
                是否确认把该应聘者标记为“{{ statusLabel }}”？</div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="isConfirm = false">取 消</el-button>
                <el-button type="primary" @click="changeStatus()">确认</el-button>
            </span>
        </el-dialog>
        <!--备注 -->
        <el-dialog title="备注" :visible.sync="isRemark" width="552px" append-to-body>
            <div class="dialog-body">
                <div class="dialog-title">
                    <el-form :inline="true" :model="form" ref="form" class="form" size="small" label-width="82px" style="width:100%" :rules="rules">
                        <el-form-item label="备注" style="margin-left: 20px;">
                            <template #label>
                                <div style="line-height: 18px;"><span style="color: #F56C6C;margin-right: 4px;">*</span>备注
                                </div>
                            </template>
                            <el-input v-model="form.remark" placeholder="请输入" maxlength="24" type="textarea" show-word-limit style="width:306px" rows="3"></el-input>
                        </el-form-item>
                    </el-form>

                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="isRemark = false">取 消</el-button>
                <el-button type="primary" @click="submitRemark()">确认</el-button>
            </span>
        </el-dialog>
        <div id="print-content" style="width:0;height:0">
            <!-- <div id="print-content" style="position: absolute; left: 0; top: 0;bottom: 0; background-color: #fff;"> -->
            <div class="pop-up-content1">
                <base-staff-record-detail-print :currentRow="currentRow"></base-staff-record-detail-print>
            </div>
        </div>
        <div id="print-content1" style="display:none">
        <!-- <div id="print-content1" style="position: absolute; left: 0; top: 0; background: #FFF; z-index: 10;"> -->
            <!-- <base-staff-record-detail-print :currentRow="currentRow"></base-staff-record-detail-print> -->
            <base-staff-record-detail :currentRow="currentRow" :row="row1"></base-staff-record-detail>
        </div>

    </div>
</template>
<script>
import eldate from '../../../components/eldate.vue'
import LbTable from '../../../components/lb-table/lb-table'
import printJS from 'print-js'
import BaseStaffRecordDetailPrint from "../components/baseStaffRecordDetailPrint";
import BaseStaffRecordDetail from "../components/baseStaffRecordDetail";
import html2Canvas from "html2canvas";
import jsPDF from "jspdf";
import html2pdf from "html2pdf.js";
import { Loading } from 'element-ui'
export default {
    name: 'roster',
    components: {
        eldate,
        LbTable,
        BaseStaffRecordDetailPrint,
        BaseStaffRecordDetail
    },
    data() {
        return {
            isConfirm: false,
            statusLabel: '录用',
            isRemark: false,
            infos: [
                {
                    title: '已面试',
                    num: '0'
                },
                {
                    title: '录用',
                    num: '0'
                },
                {
                    title: '入职',
                    num: '0'
                },
                {
                    title: '备选',
                    num: '0'
                },
                {
                    title: '淘汰',
                    num: '0'
                },
                {
                    title: '放弃入职',
                    num: '0'
                }
            ],
            showCalendar: true,
            statuss: [
                { dictId: 1, dictName: '在职' },
                { dictId: 2, dictName: '离职' },
                { dictId: 3, dictName: '待入职' }
            ],
            searchForm: {
                recruitPost: null,
                pageNo: 1,
                pageSize: 10,
                startTime: '',
                endTime: '',
                name: '',
                status: null,
                orgName: null,
                allFlag: 0,

                ids: []
            },
            applyTime: [],
            form: {
                remark: ''
            },
            rules: {
                remark: [
                    { required: true, message: '请输入备注', trigger: 'blur' }
                ]
            },
            page: {
                pageNo: 1,
                pageSize: 10
            },
            list: [],
            totalNum: 0,
            columns: [
                { type: 'selection', minWidth: '80' },
                { label: '应聘日期', prop: 'applicantTime',width: '170' },
                { label: '应聘者姓名', prop: 'name', minWidth: '120' },
                { label: '性别', prop: 'gender', minWidth: '120' },
                { label: '应聘部门', prop: 'orgName', minWidth: '140' },
                { label: '应聘岗位', prop: 'recruitPost', minWidth: '120' },
                { label: '联系电话', prop: 'phone', minWidth: '120' },
                {
                    label: '在职状态', prop: 'statusLabel', minWidth: '120',
                    render: (h, scope) => {
                        let vv = ''
                        if (scope.row.status == '1' || scope.row.status == '3') {
                            vv = <p style="color:#303033;font-size:14px;display:flex;justify-content:center;"><div style="width: 8px;height: 8px;background: #00B498;;border-radius: 50%;opacity: 1;margin-top:9px;margin-right:4px"></div>
                                <div>{scope.row.statusLabel}</div>
                            </p>
                        } else if (scope.row.status == '5' || scope.row.status == '7') {
                            vv = <p style="color:#303033;font-size:14px;display:flex;justify-content:center;"><div style="width: 8px;height: 8px;background: #E23C58;border-radius: 50%;opacity: 1;margin-top:9px;margin-right:4px"></div>
                                <div>{scope.row.statusLabel}</div>
                            </p>
                        } else if (scope.row.status == '4' || scope.row.status == '6') {
                            vv = <p style="color:#303033;font-size:14px;display:flex;justify-content:center;"><div style="width: 8px;height: 8px;background: #F5C401;border-radius: 50%;opacity: 1;margin-top:9px;margin-right:4px"></div>
                                <div>{scope.row.statusLabel}</div>
                            </p>
                        } else if (scope.row.status == '2') {
                            vv = <p style="color:#303033;font-size:14px;display:flex;justify-content:center;"><div style="width: 8px;height: 8px;background: #2D5DCF;border-radius: 50%;opacity: 1;margin-top:9px;margin-right:4px"></div>
                                <div>{scope.row.statusLabel}</div>
                            </p>
                        }
                        return (
                            <div> {vv}</div>

                            // <p style="color:#303033;font-size:14px;">{scope.row.verifyStatusLabel}</p>
                        )
                    }
                },
                { label: '关联员工', prop: 'employeeName', minWidth: '120' },
                { label: '备注', prop: 'remark', minWidth: '200' },
                {
                    label: '操作', prop: 'orgName', width: '150', fixed: 'right', align: 'center',
                    render: (h, scope) => {
                        let vv = ''
                        if (scope.row.status == '1') {
                            vv = <div style="display:flex">
                                <div style="color:#00B498;cursor:pointer;margin-right:8px" onClick={() => { this.lookDetail(scope.row, scope.$index) }} >查看</div>
                                <div style="color:#00B498;cursor:pointer;margin-right:8px" onClick={() => { this.print(scope.row, scope.$index) }} >打印</div>
                                <div>
                                    <el-dropdown onCommand={($event) => { this.command($event, scope.row) }}>
                                        <span class="el-dropdown-link" style="color:#00B498;cursor:pointer">
                                            更多<i class="el-icon-arrow-down el-icon--right"></i>
                                        </span>
                                        <el-dropdown-menu slot="dropdown">
                                            <el-dropdown-item class="custom-item" command="down">下载简历</el-dropdown-item>
                                            <el-dropdown-item class="custom-item" command="hire">录用</el-dropdown-item>
                                            <el-dropdown-item class="custom-item" command="spare">备选</el-dropdown-item>
                                            <el-dropdown-item class="custom-item" command="eliminate">淘汰</el-dropdown-item>
                                            <el-dropdown-item class="custom-item" command="remark">备注</el-dropdown-item>

                                        </el-dropdown-menu>
                                    </el-dropdown>
                                </div>
                            </div >
                        } else if (scope.row.status == '5') {
                            vv = <div style="display:flex">
                                <div style="color:#00B498;cursor:pointer;margin-right:8px" onClick={() => { this.lookDetail(scope.row, scope.$index) }} >查看</div>
                                <div style="color:#00B498;cursor:pointer;margin-right:8px" onClick={() => { this.print(scope.row, scope.$index) }} >打印</div>
                                <div>
                                    <el-dropdown onCommand={($event) => { this.command($event, scope.row) }}>
                                        <span class="el-dropdown-link" style="color:#00B498;cursor:pointer">
                                            更多<i class="el-icon-arrow-down el-icon--right"></i>
                                        </span>
                                        <el-dropdown-menu slot="dropdown">
                                            <el-dropdown-item class="custom-item" command="down">下载简历</el-dropdown-item>
                                            <el-dropdown-item class="custom-item" command="hire">录用</el-dropdown-item>
                                            <el-dropdown-item class="custom-item" command="spare">备选</el-dropdown-item>
                                            {/* <el-dropdown-item class="custom-item" command="eliminate">淘汰</el-dropdown-item> */}
                                            <el-dropdown-item class="custom-item" command="remark">备注</el-dropdown-item>

                                        </el-dropdown-menu>
                                    </el-dropdown>
                                </div>
                            </div >
                        } else if (scope.row.status == '4') {
                            vv = <div style="display:flex">
                                <div style="color:#00B498;cursor:pointer;margin-right:8px" onClick={() => { this.lookDetail(scope.row, scope.$index) }} >查看</div>
                                <div style="color:#00B498;cursor:pointer;margin-right:8px" onClick={() => { this.print(scope.row, scope.$index) }} >打印</div>
                                <div>
                                    <el-dropdown onCommand={($event) => { this.command($event, scope.row) }}>
                                        <span class="el-dropdown-link" style="color:#00B498;cursor:pointer">
                                            更多<i class="el-icon-arrow-down el-icon--right"></i>
                                        </span>
                                        <el-dropdown-menu slot="dropdown">
                                            <el-dropdown-item class="custom-item" command="down">下载简历</el-dropdown-item>
                                            <el-dropdown-item class="custom-item" command="hire">录用</el-dropdown-item>
                                            {/* <el-dropdown-item class="custom-item" command="spare">备选</el-dropdown-item> */}
                                            <el-dropdown-item class="custom-item" command="eliminate">淘汰</el-dropdown-item>
                                            <el-dropdown-item class="custom-item" command="remark">备注</el-dropdown-item>

                                        </el-dropdown-menu>
                                    </el-dropdown>
                                </div>
                            </div >
                        } else if (scope.row.status == '2') {
                            vv = <div style="display:flex">
                                <div style="color:#00B498;cursor:pointer;margin-right:8px" onClick={() => { this.lookDetail(scope.row, scope.$index) }} >查看</div>
                                <div style="color:#00B498;cursor:pointer;margin-right:8px" onClick={() => { this.print(scope.row, scope.$index) }} >打印</div>
                                <div>
                                    <el-dropdown onCommand={($event) => { this.command($event, scope.row) }}>
                                        <span class="el-dropdown-link" style="color:#00B498;cursor:pointer">
                                            更多<i class="el-icon-arrow-down el-icon--right"></i>
                                        </span>
                                        <el-dropdown-menu slot="dropdown">
                                            <el-dropdown-item class="custom-item" command="down">下载简历</el-dropdown-item>
                                            {/* <el-dropdown-item class="custom-item" command="hire">录用</el-dropdown-item> */}
                                            <el-dropdown-item class="custom-item" command="spare">备选</el-dropdown-item>
                                            <el-dropdown-item class="custom-item" command="eliminate">淘汰</el-dropdown-item>
                                            <el-dropdown-item class="custom-item" command="abndon">放弃入职</el-dropdown-item>
                                            <el-dropdown-item class="custom-item" command="remark">备注</el-dropdown-item>

                                        </el-dropdown-menu>
                                    </el-dropdown>
                                </div>
                            </div >
                        } else if (scope.row.status == '3' || scope.row.status == '7') {
                            vv = <div style="display:flex">
                                <div style="color:#00B498;cursor:pointer;margin-right:8px" onClick={() => { this.lookDetail(scope.row, scope.$index) }} >查看</div>
                                <div style="color:#00B498;cursor:pointer;margin-right:8px" onClick={() => { this.print(scope.row, scope.$index) }} >打印</div>
                                <div>
                                    <el-dropdown onCommand={($event) => { this.command($event, scope.row) }}>
                                        <span class="el-dropdown-link" style="color:#00B498;cursor:pointer">
                                            更多<i class="el-icon-arrow-down el-icon--right"></i>
                                        </span>
                                        <el-dropdown-menu slot="dropdown">
                                            <el-dropdown-item class="custom-item" command="down">下载简历</el-dropdown-item>
                                            <el-dropdown-item class="custom-item" command="remark">备注</el-dropdown-item>

                                        </el-dropdown-menu>
                                    </el-dropdown>
                                </div>
                            </div >
                        } else if (scope.row.status == '6') {
                            vv = <div style="display:flex">
                                <div style="color:#00B498;cursor:pointer;margin-right:8px" onClick={() => { this.lookDetail(scope.row, scope.$index) }} >查看</div>
                                <div style="color:#00B498;cursor:pointer;margin-right:8px" onClick={() => { this.print(scope.row, scope.$index) }} >打印</div>
                                <div>
                                    <el-dropdown onCommand={($event) => { this.command($event, scope.row) }}>
                                        <span class="el-dropdown-link" style="color:#00B498;cursor:pointer">
                                            更多<i class="el-icon-arrow-down el-icon--right"></i>
                                        </span>
                                        <el-dropdown-menu slot="dropdown">
                                            <el-dropdown-item class="custom-item" command="down">下载简历</el-dropdown-item>
                                            <el-dropdown-item class="custom-item" command="hire">录用</el-dropdown-item>
                                            <el-dropdown-item class="custom-item" command="remark">备注</el-dropdown-item>

                                        </el-dropdown-menu>
                                    </el-dropdown>
                                </div>
                            </div >
                        }
                        return (
                            <div>{vv}</div>
                        )
                    }
                },
            ],
            drawer: false,
            direction: 'rtl',
            tags: [
                {
                    label: '员工信息',
                    name: '1'
                },
                {
                    label: '角色权限',
                    name: '2'
                }
            ],
            activeName: '1',
            arr1: [
                {}, {

                }
            ],
            dictionaries: {},
            options: [],
            detail: {},
            currentRow: [],
            row1: {},
            selectIds: [],
            pId: '',
            positions: []
        }
    },
    created() {
        console.log(111)
        this.getStatus()
        this.dictionaries = this.fmObjToArr(JSON.parse(sessionStorage.getItem('dictionaries')))
        this.department()
        this.dict('recruit_post')
        this.dict('recruit_status')
        // this.fetchData()
        this.getPosition()
    },
    mounted() {

    },
    activated() { 
        this.fetchData()
    },
    methods: {
        getPosition() {

            this.axios.get('/oa/sys/org/list').then((res) => {
                if (res.code == 0) {
                    this.positions = res.data
                }
                console.log(res)
            }).catch((err) => {
                console.log(err)
            })
        },
        deliverData() {
            if (this.searchForm.ids.length == 0) {
                this.$message.warning('请勾选导出的数据')
            } else {
                this.axios.post('/oa/sys/applicant/export', this.searchForm).then(res => {
                    if (res.code == 0) {
                        this.downloadlink(res.data)
                        this.$message({
                            type: 'success',
                            message: '导出成功!'
                        })

                    }
                })
            }

        },
        downloadlink(url) {
            const iframe = document.createElement('iframe')
            iframe.style.display = 'none'
            iframe.src = url
            document.body.appendChild(iframe)
        },
        submitRemark() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    let data = {
                        id: this.pId,
                        remark: this.form.remark
                    }
                    this.axios.put('/oa/sys/applicant/remark', data).then((res) => {
                        if (res.code == 0) {
                            this.$message.success('备注成功')
                            this.isRemark = false
                            this.fetchData()
                        } else {
                            this.$message.error(res.message)
                        }
                    })
                } else {
                    return false
                }
            })

        },
        changeStatus() {
            if (this.statusLabel == '录用' || this.statusLabel == '备选' || this.statusLabel == '淘汰' || this.statusLabel == '放弃入职' || this.statusLabel == '离职') {
                let status = 2
                if (this.statusLabel == '录用') {
                    status = 2
                } else if (this.statusLabel == '备选') {
                    status = 4
                } else if (this.statusLabel == '淘汰') {
                    status = 5
                } else if (this.statusLabel == '放弃入职') {
                    status = 6
                } else if (this.statusLabel == '离职') {
                    status = 7
                }
                this.axios.put('/oa/sys/applicant/status', { id: this.pId, status: status }).then((res) => {
                    if (res.code == 0) {
                        this.fetchData()
                        this.$message.success('更改成功')
                        this.isConfirm = false
                    } else {
                        this.$message.error(res.message)
                    }

                })
            }
        },
        command(command, val) {
            if (command == 'down') {
                this.selectIds = []
                this.selectIds.push(val.id)
                this.searchForm.ids = this.selectIds
                this.axios.post('/oa/sys/applicant/detail/list', this.searchForm).then((res) => {
                    // console.log('down', res)
                    if (res.code == 0) {
                        this.currentRow = res.data
                        if (Array.isArray(this.currentRow) && this.currentRow.length > 0) {
                            this.currentRow.forEach(e => {
                                if (!e.trainingInfoList) {
                                    e.trainingInfoList = []
                                }
                            })
                        }
                        this.downloadPdf(val.name)
                    } else {
                        this.$message.error(res.message)
                    }
                })

            } else if (command == 'hire') {
                this.isConfirm = true
                this.statusLabel = '录用'
                this.pId = val.id
            } else if (command == 'spare') {
                this.isConfirm = true
                this.statusLabel = '备选'
                this.pId = val.id
            } else if (command == 'eliminate') {
                this.isConfirm = true
                this.statusLabel = '淘汰'
                this.pId = val.id
            } else if (command == 'abndon') {
                this.isConfirm = true
                this.statusLabel = '放弃入职'
                this.pId = val.id
            } else if (command == 'leave') {
                this.isConfirm = true
                this.statusLabel = '离职'
                this.pId = val.id
            } else {
                this.isRemark = true
                this.form.remark = val.remark
                this.pId = val.id
            }
        },
        alotPrint() {
            if( this.searchForm.ids.length == 0){
            // if (this.selectIds.length == 0) {
                this.$message.error('请选择需要打印的简历')
            } else {
                // this.searchForm.ids = this.selectIds
                if (this.searchForm.allFlag == 1) {
                    this.searchForm.ids = []
                }
                this.axios.post('/oa/sys/applicant/detail/list', this.searchForm).then((res) => {
                    console.log(res)
                    if (res.code == 0) {
                        this.currentRow = res.data
                        if (Array.isArray(this.currentRow) && this.currentRow.length > 0) {
                            this.currentRow.forEach(e => {
                                if (!e.trainingInfoList) {
                                    e.trainingInfoList = []
                                }
                            })
                            setTimeout(() => {
                            printJS({
                                printable: 'print-content', // 需要打印的元素的ID
                                type: 'html',
                                documentTitle: '应聘明细',
                                style: '@page { size: auto;  margin:8mm 5mm 4mm 4mm;},.page-break {page-break-after: always;},@media print {.person-info{display: flex} .person-left{width:320px;} .avatar{ width: 120px;height: 200px;margin-left:20px} .content{display:flex;justify-content:space-between;flex-wrap:wrap;}.item{display:flex;line-height:30px;min-width:50%} .person-right{flex:1} .title {font-weight: bold;}  .trhead td{text-align: center;} }',
                                scanStyles: false
                            });
                        }, 1000)
                        }
                        
                    } else {
                        this.$message.error(res.message)
                    }
                })
            }
        },
        downloadPdf(name) {
            document.querySelectorAll('iframe').forEach(function (iframe) {
                iframe.remove();
            });
            let that = this;
            setTimeout(() => {
                const loading = that.$loading({
                    lock: true,
                    text: '正在生成PDF...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });

                const element = document.getElementById('print-content1');
                element.style.display = 'block';

                // 配置选项
                const opt = {
                    margin: 0,
                    filename: `${name}.pdf`,
                    image: {
                        type: 'jpeg',
                        quality: 0.98
                    },
                    html2canvas: {
                        scale: 3, // 提高清晰度
                        useCORS: true, // 允许跨域图片
                        letterRendering: true,
                        scrollY: 0,
                        scrollX: 0,
                        windowWidth: element.scrollWidth,
                        windowHeight: element.scrollHeight
                    },
                    jsPDF: {
                        unit: 'mm',
                        format: 'a4',
                        orientation: 'portrait',
                        compress: true
                    },
                    pagebreak: { mode: ['avoid-all', 'css', 'legacy'] }
                };

                // 使用 import 动态导入，避免全局引入
                html2pdf()
                    .from(element)
                    .set(opt).save().then(() => {
                        element.style.display = 'none';
                        loading.close();
                        this.$message.success('PDF生成成功');
                    })
            }, 500)

        },
        getDetail(id) {
            this.selectIds = []
            this.selectIds.push(id)
            this.searchForm.ids = this.selectIds
            this.axios.post('/oa/sys/applicant/detail/list', this.searchForm).then((res) => {
                console.log(res)
                if (res.code == 0) {
                    this.currentRow = res.data
                    if (Array.isArray(this.currentRow) && this.currentRow.length > 0) {
                        this.currentRow.forEach(e => {
                            if (!e.trainingInfoList) {
                                e.trainingInfoList = []
                            }
                        })
                    }
                } else {
                    this.$message.error(res.message)
                }
            })

        },
        print(row) {
            this.getDetail(row.id)
            setTimeout(() => {
                printJS({
                    printable: 'print-content', // 需要打印的元素的ID
                    type: 'html',
                    documentTitle: '应聘明细',
                    style: '@page { size: auto; margin:8mm 5mm 4mm 4mm;},.page-break {page-break-after: always;},@media print {.person-info{display: flex} .person-left{width:320px;} .avatar{ width: 120px;height: 200px;margin-left:20px} .content{display:flex;justify-content:space-between;flex-wrap:wrap;}.item{display:flex;line-height:30px;min-width:50%} .person-right{flex:1} .title {font-weight: bold;}  .trhead td{text-align: center;} }',
                    scanStyles: false
                });
            }, 1000)
        },
        fetchData(type) {
            if (type == 'reset') {
                this.searchForm = {
                    recruitPost: null,
                    pageNo: 1,
                    pageSize: 10,
                    startTime: '',
                    endTime: '',
                    name: '',
                    status: null,
                    orgName: null,
                    allFlag: 0,
                    ids: []

                }
                this.page.pageNo = 1;
                this.applyTime = []
            } else {
                if (this.applyTime && this.applyTime.length > 0) {
                    this.searchForm.startTime = this.applyTime[0]
                    this.searchForm.endTime = this.applyTime[1]
                } else {
                    this.searchForm.startTime = ''
                    this.searchForm.endTime = ''
                }

            }
            this.searchForm.pageNo = this.page.pageNo
            this.searchForm.pageSize = this.page.pageSize
            if (type == 'search') {
                this.searchForm.pageNo = 1
                this.page.pageNo = 1
            }
            // if (this.searchForm.orgName) {
            //     this.searchForm.orgName = this.searchForm.orgName[this.searchForm.orgName.length - 1]
            // }
            this.searchForm.ids = []
            this.axios.post('/oa/sys/applicant/page', this.searchForm).then((res) => {
                console.log(res)
                if (res.code == 0) {
                    this.list = res.data.list || []
                    this.totalNum = res.data.totalNum
                } else {
                    this.$message.error(res.message)
                }
            })
        },
        handleSelectOrgId(e) {
            this.searchForm.orgName = e
        },
        // 部门选择列表
        department() {
            this.axios
                .post(
                    "/sys/v1/org/tree/select",
                    {
                        request: {
                            orgName: "",
                            orgType: "",
                        },
                        version: "",
                    },
                    {
                        headers: {
                            isLoading: false,
                        },
                    }
                )
                .then((res) => {
                    console.log(res);
                    if (res.code == 0) {
                        this.options = res.data;
                    } else {
                        this.$message.error(res.message);
                    }
                });
        },
        changeData(val) {
            this.applyTime = val
        },
        dict(val) {
            this.dictionaries.forEach((item) => {
                console.log(item)
                if (item.value == val) {
                    this.dictionaries[val] = item.label
                }
            })
        },
        fmObjToArr(data) {
            let arr = []
            for (let key in data) {
                let tem = []
                for (let i in data[key]) {
                    let obj = {
                        dictId: i,
                        dictName: data[key][i]

                    }
                    tem.push(obj)
                }
                arr.push({
                    label: tem, // label 字段
                    value: key   // value字段
                })
            }
            console.log(arr)
            return arr
        },
        lookDetail(val) {
            // this.drawer = true
            // this.getDetail(val.id)
            this.$router.push({ path: '/hireManagement/editApplication', query: { id: val.id } })
        },
        add() {
            this.$router.push({ path: '/hireManagement/addApplication' })
        },
        onMultipleSelection(val) {
            // if (val.length == this.page.pageSize) {
            //     this.searchForm.allFlag = 1
            // }
            if (val) {
                this.searchForm.ids = val.map((item) => {
                    return item.id
                })
            }

        },
        handleCurrentChange(e) {
            this.page.pageNo = e
            this.fetchData()
        },
        handleSizeChange(e) {
            this.page.pageSize = e
            this.fetchData()
        },
        getStatus() {
            this.axios.get('/oa/sys/applicant/status/statistics', {}).then((res) => {
                if (res.code == 0) {
                    this.infos[0].num = res.data.interviewedCount
                    this.infos[1].num = res.data.hiredCount
                    this.infos[2].num = res.data.joinedCount
                    this.infos[3].num = res.data.alternateCount
                    this.infos[4].num = res.data.eliminatedCount
                    this.infos[5].num = res.data.offerDeclinedCount
                }
                console.log(res)
            }).catch((err) => {
                console.log(err)
            })
        },
        getList() {
            this.axios.post('sys/v2/user/employee/pageList', {}).then((res) => {
                if (res.code == 0) {
                    this.list = res.data.list
                    this.totalNum = res.data.totalNum
                }
                console.log(res)
            }).catch((err) => {
                console.log(err)
            })
        }
    }
}
</script>

<style scoped lang="scss">
.pop-up-content1 {
    height: 550px;
    overflow: auto;
    width: 100%;
    max-width: 1100px;
}

.pop-up-content2 {
    width: 100%;
    padding-left: 10%;
    padding-right: 10%;
    box-sizing: border-box;
    // height: 1000px;
    // overflow: auto;
    // max-width: 1100px;

}

.container {
    width: 100%;
    height: 100%;

    .info {
        width: 100%;
        height: 121px;
        background: #FFFFFF;
        display: flex;
        justify-content: space-between;
        align-items: center;
        // margin-top: 16px;
        border-radius: 12px;
        .info-item {
            width: 268px;
            height: 121px;
            background: #FFFFFF;
            border-radius: 12px 12px 12px 12px;
            // padding: 24px 32px;
            box-sizing: border-box;
            display: flex;
            justify-content: space-between;

            .title {
                font-family: PingFang SC, PingFang SC;
                font-weight: 400;
                font-size: 16px;
                color: #939696;
                line-height: 22px;
            }

            .num {
                font-family: D-DIN Exp-DINExp, D-DIN Exp-DINExp;
                font-weight: bold;
                font-size: 32px;
                color: #2F3030;
                line-height: 22px;
                margin-top: 16px;
            }

            .line {
                width: 2px;
                height: 56px;
                background: #EDF2F2;
                border-radius: 0px 0px 0px 0px;
                margin-top: 30px;
                clear: both;
            }
        }
    }

    .content {
        width: 100%;
        min-height: calc(100vh - 254px);
        margin-top: 16px;
        background-color: white;
        padding-left: 16px;
        padding-right: 16px;
        box-sizing: border-box;
        padding-bottom: 16px;
        border-bottom:32px solid #F5FAF9;
        border-radius: 8px 8px 8px 8px / 8px 8px 40px 40px;
        .search-form {
            padding-top: 32px;
        }

        .line {
            width: 100%;
            height: 1px;
            background: #EDF2F2;
            border-radius: 0px 0px 0px 0px;
            margin-top: 16px;
        }

        .data-title {
            width: 100%;
            height: 32px;
            margin-top: 20px;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .title-line {
                width: 2px;
                height: 16px;
                background: #00B498;
                border-radius: 0px 0px 0px 0px;
                margin-top: 8px;
            }

            .title-name {
                font-family: PingFang SC, PingFang SC;
                font-weight: bold;
                font-size: 16px;
                color: #2F3030;
                margin-left: 4px;
                line-height: 32px;
            }

            .title-btn {
                display: flex;

                .title-btn-item {
                    min-width: 92px;
                    height: 32px;
                    background: #FFFFFF;
                    border-radius: 4px 4px 4px 4px;
                    border: 1px solid #E3E6E5;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    padding-left: 8px;
                    padding-right: 8px;
                    box-sizing: border-box;
                    cursor: pointer;

                    .btn-l {
                        font-family: PingFang SC, PingFang SC;
                        font-weight: 400;
                        font-size: 14px;
                        color: #2F3030;

                    }
                }


            }
        }
    }


}

.main {
    position: relative;
    // padding-top: 24px;
    // height: 100%;
    box-sizing: border-box;
    padding-left: 24px;
    padding-right: 24px;

    .split-line {
        width: 1380px;
        height: 1px;
        background: #EDF2F2;
        border-radius: 0px 0px 0px 0px;
        margin-top: 14px;
    }

    .title {
        font-family: PingFang SC, PingFang SC;
        font-weight: bold;
        font-size: 16px;
        color: #2F3030;
        margin-top: 32px;
    }

    .content-h {
        width: 100%;
        height: 124px;
        background: #F8FAFA;
        border-radius: 4px 4px 4px 4px;
        margin-top: 24px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 16px 20px;
        box-sizing: border-box;

        .content-h-l {

            display: flex;
            justify-content: space-between;
            align-items: center;

            .content-h-l-c {
                margin-left: 12px;

                .name {
                    font-family: PingFang SC, PingFang SC;
                    font-weight: bold;
                    font-size: 20px;
                    color: #2F3030;
                    line-height: 28px;
                    text-align: left;
                }

                .sex-m {
                    width: 20px;
                    height: 20px;
                    background: #E4F7F4;
                    border-radius: 2px 2px 2px 2px;
                    text-align: center;
                    color: rgba(45, 93, 207, 1);
                    margin-top: 4px;
                    margin-left: 6px;
                }

                .sex-w {
                    width: 20px;
                    height: 20px;
                    border-radius: 2px 2px 2px 2px;
                    text-align: center;
                    background: #FFE8EC;
                    margin-top: 4px;
                    margin-left: 6px;
                    color: rgba(226, 60, 88, 1)
                }

                .status {
                    width: 54px;
                    height: 24px;
                    background: #E4F7F4;
                    border-radius: 2px 2px 2px 2px;
                    font-family: PingFang SC, PingFang SC;
                    font-weight: 400;
                    font-size: 14px;
                    color: #00B498;
                    line-height: 24px;
                    text-align: center;
                    margin-top: 2px;
                    margin-left: 22px
                }

                .text {
                    font-family: PingFang SC, PingFang SC;
                    font-weight: 400;
                    font-size: 14px;
                    color: #2F3030;
                    margin-right: 40px;
                }
            }
        }

        .content-h-r {
            .time {
                font-family: PingFang SC, PingFang SC;
                font-weight: 400;
                font-size: 14px;
                color: #939696;
                line-height: 0px;
                text-align: right;
                margin-top: -30px;
            }
        }
    }

    .content-c {
        margin-top: 30px;

        .l-form {
            .el-form-item {
                // width: 290px;
                width: 24%;
            }

            /deep/.el-form-item__label {
                color: #939696;
            }
        }

        .text-f {
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #2F3030;
            line-height: 32px;
        }

        .relative {
            width: 100%;
            height: 52px;
            background: #F8FAFA;
            border-radius: 0px 0px 0px 0px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
        }

        .sort-index {
            width: 16px;
            height: 16px;
            background: #E4F7F4;
            line-height: 16px;
            border-radius: 50%;
            font-family: PingFang SC, PingFang SC;
            font-weight: bold;
            font-size: 12px;
            color: #00B498;
            text-align: center;
        }

        .sort-title {
            font-family: PingFang SC, PingFang SC;
            font-weight: bold;
            font-size: 14px;
            color: #2F3030;
            margin-left: 2px;
        }
    }

    .main-content {
        margin-top: 30px;

    }

    .back {
        width: 1436px;
        height: 68px;
        background: #FFFFFF;
        border-radius: 0px 0px 0px 8px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        position: fixed;
        right: 0;
        bottom: 0;
        border-top: 1px solid #EDF2F2;

        .back-btn {
            width: 88px;
            height: 36px;
            background: #EDF2F2;
            border-radius: 4px 4px 4px 4px;
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #939696;
            line-height: 36px;
            text-align: center;
            margin-left: 24px;

        }
    }
}
</style>